import React from "react";
import DealScore from "../../deal-score";
import StringProcessingService from "../../../services/string-processing-service";

import '../../../lib/slick-1.8.1/slick.css';
import '../../../lib/slick-1.8.1/slick-theme.css';

import '../listing-page-style.css';


export default function ListingHeader(props) {
    const stringProcessingService = new StringProcessingService();
    const {
        data, 
        dictionary, 
        width, 
        analyseInfo, 
        handleDealScore,
        project
    } = props;


    const { 
        ListPrice, list_price,
        LivingArea, living_area, 
        LotSizeSquareFeet, lot_size_square_feet,
        StreetNumber, street_number,
        StreetName, street_name,
        UnitNumber, unit_number,
        City, city,
        StateOrProvince, state_or_province,
        PostalCode, postal_code,
        BedroomsTotal, bedrooms_total,
        BathroomsTotalDecimal, bathrooms_total_decimal
    } = data;

    const price = ListPrice ?? list_price;
    const area = LivingArea ?? living_area;
    const lotSize = LotSizeSquareFeet ?? lot_size_square_feet;
    const streetNum = StreetNumber ?? street_number;
    const streetNm = StreetName ?? street_name;
    const unitNum = UnitNumber ?? unit_number;
    const cityName = City ?? city;
    const state = StateOrProvince ?? state_or_province;
    const zip = PostalCode ?? postal_code;
    const beds = BedroomsTotal ?? bedrooms_total;
    const baths = BathroomsTotalDecimal ?? bathrooms_total_decimal;


    let ParsedListingPrice = stringProcessingService.convertToFormat(price.toString());
    let ParsedSquareFeet = '';
    if (data.PropertyType !== "Land/Boat Docks" && area) {
        ParsedSquareFeet = stringProcessingService.convertToFormat(area.toString());
    } else if (lotSize) {
        ParsedSquareFeet = stringProcessingService.convertToFormat(lotSize.toString());
    }


    return (
        <div className={"ListinPageHeaderLine"}>
            <div className="ListinPageStaticHeader">
                <div className="Title">
                    {project ? 
                        null :
                        <div className={"VertLine"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="64.484" viewBox="0 0 2 64.484">
                                <defs>
                                    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stopColor="#a96903" />
                                        <stop offset="0.258" stopColor="#aa6a02" />
                                        <stop offset="0.352" stopColor="#b07102" />
                                        <stop offset="0.418" stopColor="#b97d02" />
                                        <stop offset="0.472" stopColor="#c78e01" />
                                        <stop offset="0.518" stopColor="#daa401" />
                                        <stop offset="0.557" stopColor="#f0be00" />
                                        <stop offset="0.579" stopColor="#ffd100" />
                                        <stop offset="1" stopColor="#a96903" />
                                    </linearGradient>
                                </defs>
                                <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-272.933 -2822.173) rotate(90)">
                                    <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="64.484" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                </g>
                            </svg>
                        </div>    
                    }
                    <h1 style={{width: '100%'}}>
                        {
                            project ?
                            <div className="ProjectHeaderLogo">
                                <img src={`https://ngirealty.com/img/projects/${project.id}/${project.logo}`} alt="Project Logo"/>
                                <div className="ProjectHeaderName">
                                    {project.name}
                                </div>
                            </div>
                            :
                            <div className="TitieAndDisc">
                                <div>
                                    {/* 18555 Collins Avenue, Unit 4803 */}
                                    {`${streetNum} ${streetNm} ${unitNum != null ? ('#' + unitNum) : ("")}`}

                                </div>
                                {`${cityName}, ${state} ${zip}`}

                            </div>
                        }
                    </h1>

                </div>
                <div className="MainInfoAndDealScoreAtTop">
                    <div className="MainInfo">
                        <div className="Item">
                            {dictionary.bedrooms}:   <br /><span>   {beds != null && beds !== '' ? beds : (`N/A`)}  </span>
                        </div>
                        <div className="Item">
                            {dictionary.bathrooms}:  <br /> <span> {baths != null && baths !== '' ? baths : (`N/A`)} </span>
                        </div>
                        <div className="Item">
                            {dictionary.area_metric_full}:  <br /> <span> {ParsedSquareFeet != null && ParsedSquareFeet !== '' ? ParsedSquareFeet : (`N/A`)}</span>
                        </div>
                        <div className="Item Last PriceInRow Price">
                            <div>
                                {dictionary.listing_price}:  <br /> <span>${(ParsedListingPrice != null && ParsedListingPrice !== '') ? (ParsedListingPrice) : (`N/A`)}</span>
                            </div>
                        </div>
                    </div>

                    <div className={"DealScoreAtTop"} onClick={handleDealScore}>
                        <DealScore
                            dictionary={dictionary}
                            width={width}
                            for_top={true}
                            analyseInfo={analyseInfo}
                            handleDealScore={handleDealScore}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}